import React from "react";
import MaskShapeContainer, {
  MaskType,
} from "../../MaskShapeContainer/MaskShapeContainer";
import AudioIcon from "../../../assets/icons/Audio.svg";

interface IPodcastHeader {
  image?: string;
  imageMobile?: string;
  classNameImage?: string;
  height?: string;
  width?: string;
  backgroundGradientHeight?: string;
  backgroundGradient?: string;
  icon?: React.ReactNode;
  texture?: React.ReactNode;
  title?: string;
  episode?: string;
  textureStyles?: string;
}

const PodcastHeader = ({
  height = "h-full",
  width = "w-full",
  backgroundGradient,
  backgroundGradientHeight,
  image,
  imageMobile,
  classNameImage,
  episode,
  texture,
  title,
  textureStyles,
}: IPodcastHeader) => {
  return (
    <>
      <MaskShapeContainer
        maskType={MaskType.BottomBow}
        className={`${height} ${width} relative`}
      >
        <div
          className={`${backgroundGradientHeight} ${backgroundGradient} absolute top-0 w-full overflow-hidden`}
        >
          <div className="w-full h-full flex justify-end p-[0_1.5rem_1.5rem_0] md:p-[0_2.5rem_2.5rem_0]">
            <div className={`absolute ${textureStyles}`}>{texture}</div>
            <img src={image} className={`absolute left-0 z-10 ${imageMobile ? 'hidden md:block' : ''} ${classNameImage}`} loading="lazy" />
            {imageMobile && <img src={imageMobile} className={`absolute left-0 block md:hidden z-10 ${classNameImage}`} loading="lazy" />}
            <div className="flex flex-col-reverse md:flex-row items-end md:items-center justify-between text-white md:w-[65%] mt-[5rem] md:mt-[10rem]">
              <div className="w-full flex flex-col items-end justify-end">
                <h3 className="text-right"> {title} </h3>
                <p className="subtitle-3 hidden md:block">{episode}</p>
              </div>
              <div className="bg-[#24135FB3] w-fit h-fit p-[0.5rem] rounded-[50%] ml-[2rem]">
                <AudioIcon className="w-[3.5rem] h-[3.5rem]" />
              </div>
              <p className="subtitle-3 block md:hidden">{episode}</p>
            </div>
          </div>
        </div>
      </MaskShapeContainer>
    </>
  );
};

export default PodcastHeader;
